function ValentinePrompt() {
  return (
    <div className="prompt-block">
      <p className="eyebrow">Quick question</p>
      <h1 className="prompt">Will you be my Valentine?</h1>
      <p className="subtext">
        I promise we will have a good time, and I might even have one good joke.
      </p>
    </div>
  );
}

export default ValentinePrompt;
